import { BrandingConfig } from '~/api/types';

function clearExistingIconLinks() {
  document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]').forEach((link) => link.remove());
}

function addIconLink(href: string, options?: { type?: string; sizes?: string }) {
  const link = document.createElement('link');
  link.rel = 'icon';
  if (options?.type) link.type = options.type;
  if (options?.sizes) link.setAttribute('sizes', options.sizes);
  link.href = href;
  document.head.appendChild(link);
}

export function applyFavicon(branding?: Pick<BrandingConfig, 'faviconUrl' | 'companyLogoUrl'> | null) {
  clearExistingIconLinks();

  const customIconUrl = branding?.faviconUrl || branding?.companyLogoUrl;
  if (customIconUrl) return addIconLink(customIconUrl);

  addIconLink('/favicon-32x32.png', { type: 'image/png', sizes: '32x32' });
  addIconLink('/favicon-16x16.png', { type: 'image/png', sizes: '16x16' });
}
